export const translations = {
  hr: {
    // Navbar
    navHome: "Početna",
    navStory: "Naša priča",
    navInfo: "Informacije",
    navGallery: "Galerija",
    navContact: "Kontakt",
    navRsvp: "RSVP",

    // Hero / Home Main
    homeIntro:
      "S velikom radošću vas pozivamo da nam se pridružite u proslavi našeg vjenčanja",
    homeCeremonyTitle: "Ceremonija",
    homeCeremonyLocation: "Bazilika sv. Antuna Padovanskog",
    homeCeremonyTime: "Zagreb, 16:00h",
    homeCelebrationTitle: "Proslava",
    homeCelebrationLocation: "Utvrda Medvedgrad",
    homeCelebrationTime: "Zagreb, Hrvatska",
    homeViewMap: "Pogledaj kartu",
    homeRsvpNote: "Molimo potvrdite dolazak do 1. lipnja",

    // Our Story
    storyJourney: "Putovanje",
    storyTitle: "Naša Priča",
    storyText1:
      "Sve je počelo jednim slučajnim susretom koji je brzo prerastao u nešto puno više. Od prvih zajedničkih putovanja do toplih večeri u Zagrebu, gradili smo svijet pun smijeha, podrške i ljubavi.",
    storyQuote:
      '"Ljubav se ne sastoji od gledanja jedno u drugo, već u gledanju u istom smjeru."',
    storyText2:
      "Nakon godina zajedničkog rasta, odlučili smo otvoriti novo poglavlje. Veselimo se što ćemo taj trenutak proslaviti upravo s vama.",

    // Info / Details (Kraljev Vrh)
    infoTitle: "Gdje i Kada",
    infoLocation: "Lokacija",
    infoVenue: "Imanje Kraljev Vrh",
    infoAddress: "Ulica Pavla Štoosa 5, Jakovlje",
    infoTime: "Vrijeme",
    infoCeremony: "Ceremonija vjenčanja: 17:00h",
    infoMapsBtn: "Otvori u navigaciji",

    // RSVP
    rsvpTitle: "Potvrdite dolazak",
    rsvpYes: "DOLAZIM",
    rsvpNo: "NAŽALOST NE",
    rsvpAdultsTitle: "ODRASLI GOSTI",
    rsvpAdultsCancel: "TKO OTKAZUJE?",
    rsvpChildrenTitle: "DJECA",
    rsvpFirstName: "Ime",
    rsvpLastName: "Prezime",
    rsvpChildName: "Ime djeteta",
    rsvpChildAge: "Dob",
    rsvpRemove: "Ukloni",
    rsvpAddAdult: "Dodaj osobu",
    rsvpAddChild: "Dodaj dijete",
    rsvpDietaryTitle: "PREHRANA",
    rsvpDietaryPlaceholder: "Alergije, vegetarijanci, vegani...",
    rsvpMessageTitle: "PORUKA",
    rsvpMessagePlaceholder: "Vaša poruka mladencima (opcionalno)",
    rsvpConsentText:
      "Suglasan/na sam da se moji podaci koriste isključivo u svrhu organizacije vjenčanja (popis gostiju, raspored sjedenja i planiranje jelovnika).",
    rsvpSubmit: "POŠALJI ODGOVOR",
    rsvpSending: "SLANJE...",
    rsvpSuccessTitle: "Hvala vam!",
    rsvpSuccessMsg: "Vaš odgovor je uspješno poslan mladencima.",
    rsvpAlert: "Molimo označite dolazite li ili ne.",
    // Gallery
    galleryTitle: "Galerija",
    galleryViewBtn: "POGLEDAJ",

    // Contact / Footer
    contactThanks: "Hvala vam",
    contactSubtitle: "Jedva čekamo proslaviti naš poseban dan s vama!",
    contactEmailTitle: "Pišite nam",
    contactPhoneTitle: "Nazovite nas",
    contactLocationTitle: "Lokacija",
    contactCopyright: "S ljubavlju, Matea & Reiner",
  },
  en: {
    // Navbar
    navHome: "Home",
    navStory: "Our Story",
    navInfo: "Information",
    navGallery: "Gallery",
    navContact: "Contact",
    navRsvp: "RSVP",

    // Hero / Home Main
    homeIntro:
      "With great joy, we invite you to share in the celebration of our marriage",
    homeCeremonyTitle: "Ceremony",
    homeCeremonyLocation: "Basilica of St. Anthony of Padua",
    homeCeremonyTime: "Zagreb, 4:00 PM",
    homeCelebrationTitle: "Celebration",
    homeCelebrationLocation: "Medvedgrad Fortress",
    homeCelebrationTime: "Zagreb, Croatia",
    homeViewMap: "View Map",
    homeRsvpNote: "Kindly RSVP by June 1st",

    // Our Story
    storyJourney: "The Journey",
    storyTitle: "Our Story",
    storyText1:
      "It all started with a chance encounter that quickly grew into something much more. From our first trips together to warm evenings in Zagreb, we built a world full of laughter, support, and love.",
    storyQuote:
      '"Love does not consist in gazing at each other, but in looking outward together in the same direction."',
    storyText2:
      "After years of growing together, we decided to open a new chapter. We look forward to celebrating this moment with you.",

    // Info / Details
    infoTitle: "Where & When",
    infoLocation: "Location",
    infoVenue: "Kraljev Vrh Estate",
    infoAddress: "Pavla Štoosa Street 5, Jakovlje",
    infoTime: "Time",
    infoCeremony: "Wedding ceremony: 5:00 PM",
    infoMapsBtn: "Open in Maps",

    // RSVP
    rsvpTitle: "RSVP",
    rsvpYes: "JOYFULLY ACCEPTS",
    rsvpNo: "REGRETFULLY DECLINES",
    rsvpAdultsTitle: "ADULT GUESTS",
    rsvpAdultsCancel: "WHO IS DECLINING?",
    rsvpChildrenTitle: "CHILDREN",
    rsvpFirstName: "First Name",
    rsvpLastName: "Last Name",
    rsvpChildName: "Child's Name",
    rsvpChildAge: "Age",
    rsvpRemove: "Remove",
    rsvpAddAdult: "Add guest",
    rsvpAddChild: "Add child",
    rsvpDietaryTitle: "DIETARY REQUIREMENTS",
    rsvpDietaryPlaceholder: "Allergies, vegetarian, vegan...",
    rsvpMessageTitle: "MESSAGE",
    rsvpMessagePlaceholder: "Your message for the couple (optional)",
    rsvpConsentText:
      "I consent to my data being used solely for wedding organization purposes (guest list, seating chart, and meal planning).",
    rsvpSubmit: "SEND RESPONSE",
    rsvpSending: "SENDING...",
    rsvpSuccessTitle: "Thank you!",
    rsvpSuccessMsg: "Your response has been successfully sent.",
    rsvpAlert: "Please indicate whether you are attending or not.",

    // Gallery
    galleryTitle: "Gallery",
    galleryViewBtn: "VIEW",

    // Contact / Footer
    contactThanks: "Thank you",
    contactSubtitle: "We can't wait to celebrate our special day with you!",
    contactEmailTitle: "Email us",
    contactPhoneTitle: "Call us",
    contactLocationTitle: "Location",
    contactCopyright: "With love, Matea & Reiner",
  },
};
